export const nodeIcon = 'folder';
export const leafIcon = 'store';
